import React from 'react';
import { Contact } from '../components/global/contact';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;
